import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import API, {graphqlOperation} from '@aws-amplify/api-graphql';
import {
  CreateCodebookInput,
  CreateCodebookMutation,
  DeleteCodebookInput,
  DeleteCodebookMutation,
  GetCodebookByClientIDQuery,
  ModelCodebookConditionInput, ModelIDInput,
  ModelSortDirection, ModelStringInput,
  UpdateCodebookInput,
  UpdateCodebookMutation,
} from '../../../../API.service';
import {Auth} from 'aws-amplify';
import {MatSnackBar} from '@angular/material/snack-bar';
import { log } from 'console';

export interface SifrarnikModel {
  firma: string;
  idBroj: string;
  sifra: string;
  actions?: any;
}



export type ModelCodebookFilterInput = {
  id?: ModelIDInput | null;
  companyName?: ModelStringInput | null;
  idNumber?: ModelStringInput | null;
  code?: ModelStringInput | null;
  vatNumber?: ModelStringInput | null;
  clientID?: ModelIDInput | null;
  searchKeyword?: ModelStringInput | null;
  and?: Array<ModelCodebookFilterInput | null> | null;
  or?: Array<ModelCodebookFilterInput | null> | null;
  not?: ModelCodebookFilterInput | null;
};

export type GetCodebookQuery = {
  __typename?: 'Codebook';
  id?: string;
  companyName: string;
  idNumber: string;
  code: string;
  clientID?: string;
  createdAt?: string;
  updatedAt?: string;
  vatNumber?: string | null;
};

@Injectable({
  providedIn: 'root',
})
export class SifrarnikDataService {
  constructor(private snackBar: MatSnackBar,) {}

  private SIFRARNIK_DATA = new BehaviorSubject<GetCodebookQuery[]>([]);
  private dataStore: { sifre: any } = { sifre: [] };
  readonly sifre = this.SIFRARNIK_DATA.asObservable();
  private nextToken: string | undefined

  resetSifraData() {
    this.dataStore.sifre = []; // Clear the data
    this.SIFRARNIK_DATA.next([]); // Notify subscribers about the change
  }

  async CreateCodebook(
    input: CreateCodebookInput,
    condition?: ModelCodebookConditionInput
  ): Promise<CreateCodebookMutation> {
    const statement = `mutation CreateCodebook($input: CreateCodebookInput!, $condition: ModelCodebookConditionInput) {
        createCodebook(input: $input, condition: $condition) {
          __typename
          id
          companyName
          idNumber
          code
          vatNumber
          clientID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input,
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateCodebookMutation>response.data.createCodebook;
  }

  // async ListCodebooks(
  //   filter?: ModelCodebookFilterInput,
  //   limit?: 1000,
  //   nextToken?: string
  // ): Promise<ListCodebooksQuery> {
  //   const statement = `query ListCodebooks($filter: ModelCodebookFilterInput, $limit: Int, $nextToken: String) {
  //       listCodebooks(filter: $filter, limit: $limit, nextToken: $nextToken) {
  //         __typename
  //         items {
  //           __typename
  //           id
  //           companyName
  //           idNumber
  //           code
  //           clientID
  //           vatNumber
  //           createdAt
  //           updatedAt
  //         }
  //         nextToken
  //       }
  //     }`;
  //   const gqlAPIServiceArguments: any = {};
  //   if (filter) {
  //     gqlAPIServiceArguments.filter = filter;
  //   }
  //   if (limit) {
  //     gqlAPIServiceArguments.limit = limit;
  //   }
  //   if (nextToken) {
  //     gqlAPIServiceArguments.nextToken = nextToken;
  //   }
  //   const response = (await API.graphql(
  //     graphqlOperation(statement, gqlAPIServiceArguments)
  //   )) as any;
  //   return <ListCodebooksQuery>response.data.listCodebooks;
  // }


  async ListCodebooks(
    filter?: ModelCodebookFilterInput,
    limit?: 1000,
    nextToken?: string
  ): Promise<{ items: any[]; nextToken: string | null }> {
    const statement = `query ListCodebooks($filter: ModelCodebookFilterInput, $limit: Int, $nextToken: String) {
      listCodebooks(filter: $filter, limit: $limit, nextToken: $nextToken) {
        items {
          id
          companyName
          idNumber
          code
          clientID
          vatNumber
          createdAt
          updatedAt
        }
        nextToken
      }
    }`;


    let allItems: any[] = [];

    let currentToken = nextToken;
    while (true) {
      const gqlAPIServiceArguments: any = {
        filter,
        limit: 10000,
        nextToken: currentToken,
      };

      const response = (await API.graphql(
        graphqlOperation(statement, gqlAPIServiceArguments)
      )) as any;

      const items = response.data.listCodebooks.items;
      allItems = allItems.concat(items);

      currentToken = response.data.listCodebooks.nextToken;
      if (!currentToken) {
        break;
      }
    }
    return {
      items: allItems,
      nextToken: null,
    };
  }



  async DeleteCodebook(
    input: DeleteCodebookInput,
    condition?: ModelCodebookConditionInput
  ): Promise<DeleteCodebookMutation> {
    const statement = `mutation DeleteCodebook($input: DeleteCodebookInput!, $condition: ModelCodebookConditionInput) {
        deleteCodebook(input: $input, condition: $condition) {
          __typename
          id
          companyName
          idNumber
          code
          clientID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input,
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteCodebookMutation>response.data.deleteCodebook;
  }

  async UpdateCodebook(
    input: UpdateCodebookInput,
    condition?: ModelCodebookConditionInput
  ): Promise<UpdateCodebookMutation> {
    const statement = `mutation UpdateCodebook($input: UpdateCodebookInput!, $condition: ModelCodebookConditionInput) {
        updateCodebook(input: $input, condition: $condition) {
          __typename
          id
          companyName
          idNumber
          code
          vatNumber
          clientID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input,
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateCodebookMutation>response.data.updateCodebook;
  }

  async GetCodebookByClientID(
    clientID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelCodebookFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<GetCodebookByClientIDQuery> {
    const statement = `query GetCodebookByClientID($clientID: ID!, $sortDirection: ModelSortDirection, $filter: ModelCodebookFilterInput, $limit: Int, $nextToken: String) {
        getCodebookByClientID(
          clientID: $clientID
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            companyName
            idNumber
            code
            vatNumber
            clientID
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      clientID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetCodebookByClientIDQuery>response.data.getCodebookByClientID;
  }

  async initializeData(clientID: string): Promise<any> {
    return await this.GetCodebookByClientID(clientID, undefined, undefined, 50)
      .catch(err => console.log(err))
      .then((data: any) => {
        this.dataStore.sifre = data.items;
        this.SIFRARNIK_DATA.next(Object.assign({}, this.dataStore).sifre);
        if (data.nextToken) {
          this.nextToken = data.nextToken
        }
        else this.nextToken = undefined
      }
    );
  }

  async filterCodebooks(clientID: string, keyword: string): Promise<any> {
    let nextToken = null;
    this.dataStore.sifre = []; // Initialize with an empty array

    do {
        const data: any = await this.GetCodebookByClientID(
            clientID,
            undefined,
            { searchKeyword: { contains: keyword } },
            100000,
            nextToken,
        ).catch(err => {
            console.log(err);
            return null; // Handle the error appropriately
        });

        if (data) {
            console.log(data);

            // Append new items to the existing array
            this.dataStore.sifre = [...this.dataStore.sifre, ...data.items];
            console.log(this.dataStore.sifre);

            this.SIFRARNIK_DATA.next(Object.assign({}, this.dataStore).sifre);
            nextToken = data.nextToken;
        } else {
            nextToken = null; // Set nextToken to null to exit the loop in case of an error
        }
    } while (nextToken !== null);

    // Return something meaningful or void, as there is no specific return in your original code
}



  async fetchAdditionalCodebooks(clientID: string): Promise<any> {
    if (!this.nextToken) return;
    return await this.GetCodebookByClientID(clientID, undefined, undefined, 150, this.nextToken)
      .catch(err => console.log(err))
      .then((data: any) => {
        this.dataStore.sifre = this.dataStore.sifre.concat(data.items);
        this.SIFRARNIK_DATA.next(Object.assign({}, this.dataStore).sifre);
        if (data.nextToken) {
          this.nextToken = data.nextToken
        }
        else this.nextToken = undefined
      });
  }

  async addNewSifra(sifra: GetCodebookQuery) {
    const user = await Auth.currentAuthenticatedUser();
    const codebookInput: CreateCodebookInput = {
      clientID: user?.attributes.sub,
      companyName: sifra?.companyName,
      idNumber: sifra?.idNumber,
      code: sifra?.code,
      vatNumber: sifra?.vatNumber,
    };
    this.CreateCodebook(codebookInput)
      .then((data) => {
        this.dataStore.sifre.unshift(data);
        this.SIFRARNIK_DATA.next(Object.assign({}, this.dataStore).sifre);
      })
      .catch((err) => console.log(err));
  }

  async editSifra(sifraData: any) {
    let foundSifra: any = this.dataStore.sifre.find(
      (el: { id: any; }) => el.id === sifraData.id
    );
    if (foundSifra) {
      let updatedObject: any = { id: sifraData.id };
      for (const [key, value] of Object.entries(foundSifra)) {
        if (sifraData[`${key}`] !== value) {
          updatedObject[key] = sifraData[`${key}`];
        }
      }
      await this.UpdateCodebook(updatedObject)
        .then((data) => console.log(data))
        .catch((err) => console.log(err))
        .finally(() => {
          foundSifra = Object.assign(foundSifra, sifraData);
          this.SIFRARNIK_DATA.next(Object.assign({}, this.dataStore).sifre);
          this.snackBar.open('Changes successfully saved', '', {
            duration: 5000,
            panelClass: ['white-snackbar'],
          });
        });
    }
  }

  removeSifra(item: any) {
    const foundSifra = this.dataStore.sifre.find((sifra: { id: any; }) => sifra.id === item.id);
    if (foundSifra) {
      this.dataStore.sifre = this.dataStore.sifre.filter(
        (sifra: { id: any; }) => sifra.id !== foundSifra.id
      );
      this.SIFRARNIK_DATA.next(Object.assign({}, this.dataStore).sifre);
      this.DeleteCodebook({ id: item.id })
        .then((data) => {
          console.log('item', item);
          // companyName
          this.snackBar.open(`The "${item.companyName}" code has been deleted`, '', {
            duration: 5000,
            panelClass: ['white-snackbar'],
          });
          console.log(data)})
        .catch((err) => console.log(err));
    }
  }
}
